import { selector } from 'recoil'
import equipmentAtom from './atoms/equipment.atom.ts'
import objectUtils from '@/utils/object.utils.ts'

const selectEquipmentCountByStatus = selector({
  key: 'getEquipmentCountByStatus',
  get: ({ get }) => {
    const { items } = get(equipmentAtom)

    return items.reduce((acc, val) => {
      if (acc[val.state]) {
        acc[val.state]++
      } else {
        acc[val.state] = 1
      }

      return acc
    }, {})
  },
})

const selectEquipmentCountByFlag = selector({
  key: 'getEquipmentCountByFlag',
  get: ({ get }) => {
    const { items } = get(equipmentAtom)

    return items.reduce((acc, val) => {
      if (acc[val.statusFlag]) {
        acc[val.statusFlag]++
      } else {
        acc[val.statusFlag] = 1
      }

      return acc
    }, {})
  },
})

const getEquipmentMap = selector({
  key: 'getEquipmentMap',
  get: ({ get }) => {
    const { items } = get(equipmentAtom)

    return objectUtils.arrToMap(items, 'id')
  },
})

const equipmentSelectors = { selectEquipmentCountByStatus, getEquipmentMap, selectEquipmentCountByFlag }
export default equipmentSelectors
